import { Dispatch, FC, SetStateAction, KeyboardEvent } from 'react';
import { HStack, Text } from '@bpba/ui-components';
import { DataOrigin } from './useDataInputSelect';
import { StyledButton } from '../shared/StyledButton';

const KEYBOARD_ENTER = 'Enter';
const KEYBOARD_SPACE = ' ';

const DATA_ORIGIN_COUNT = Object.keys(DataOrigin).length / 2;
const OPEN_SYMBOL = '+';
const CLOSE_SYMBOL = '-';

type Props<T> = {
  title: string;
  dataOrigin: T;
  setDataOrigin: Dispatch<SetStateAction<T>>;
};

export const ButtonNewData: FC<Props<DataOrigin>> = ({ title, dataOrigin, setDataOrigin }) => {
  const newDataSelected = dataOrigin === DataOrigin.INPUT_DATA;
  const currentSymbol = newDataSelected ? CLOSE_SYMBOL : OPEN_SYMBOL;

  function toggleButton() {
    setDataOrigin((current) => {
      return (current + 1) % DATA_ORIGIN_COUNT;
    });
  }

  const onKeyDownHandler = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event?.key === KEYBOARD_ENTER) {
      event.preventDefault();
      toggleButton();
    } else if (event.key === KEYBOARD_SPACE) {
      event.preventDefault();
    }
  };

  return (
    <StyledButton
      margin="0px !important"
      px={['4px', '8px']}
      width="fit-content !important"
      height="fit-content"
      onClick={toggleButton}
      onKeyDown={onKeyDownHandler}
      variant={'icon'}
      fontWeight={800}
    >
      <HStack alignItems="center">
        <Text fontSize={3} color="primary.0" paddingBottom={newDataSelected ? '1px' : '0'}>
          {currentSymbol}
        </Text>
        <Text fontSize="13px" pl="2px" color="primary.0">
          {title}
        </Text>
      </HStack>
    </StyledButton>
  );
};
